import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components'

class SideLayout extends Component {
    render() {
        const { active, layouts } = this.props;
        return active && <>
            {
                layouts.map((item, index) => {
                    const StyledWrapper = styled.div`width: 100%;height: 100%;${item.css}`
                    return active == item.id && <div className="layoutSide">
                        <StyledWrapper>
                            {
                                item.zones.map((zItem, zIndex) => <div id={zItem.id} className="zone"></div>)
                            }
                        </StyledWrapper>
                    </div>
                })
            }
        </>
    }
}

const mapStateToProps = state => {
    return {
        layouts: state.layout.layouts
    }
}
export default connect(mapStateToProps)(SideLayout);